import React, { useEffect, useState } from 'react';
import { getSignalementForMission } from '../../../api/signalements';
import { useHistory, useParams } from 'react-router-dom';
import { GradientText } from '../../PasserCommande/PasserCommande.styles';
import LayoutChauffeur from '../../../Components/LayoutChauffeur/LayoutChauffeur';
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import toast from 'react-hot-toast';
import DetailsSignalementModal from '../../../Components/DetailsSignalement/DetailsSignalementModal';
import { useTranslation } from 'react-i18next'

function SignalerChauffeurAllMission() {

    const { id } = useParams();
    const history = useHistory();
    const token = useSelector((state) => state.auth.token);
    const [signalements, setSignalements] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [chargementEnCours, setChargementEnCours] = useState(false);
    const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
    const [signalement, setSignalement] = useState(null);
    const {t} = useTranslation()
    const fetchData = async (page, perPage) => {
        try {
            setChargementEnCours(true);
            const res = await getSignalementForMission(id, token, page, perPage);
            setSignalements(res.docs);
            setTotalRows(res.totalDocs);
        } catch (error) {
            toast.error(t("transfer_request_err"), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setChargementEnCours(false);
        }
    };
    const renderSignalementType = (type) => {
    switch (type) {
    case 'client_absent' : return "Client absent"
    case 'retard_aux_chargement' : return t("loading_delay")
    case 'livraison_reportée': return t("delivery_postponed")
    case 'retard_aux_déchargement': return t("unloading_delay")
    case 'marchandises_manquantes_chargement':return t("missing_goods") 
    case 'marchandise_refusée': return t("goods_refused")
    case 'marchandises_incomplètes':return  t("incomplete_goods")
    case 'marchandise_abîmée':return  t("damaged_goods")
    case 'route_inaccessible_fermée': return t("road_inaccessible")
    case 'circulation_dense': return t("heavy_traffic")
    case 'anomalie_course': return t("trip_anomaly")
    case 'autre': return t("other_specify")
	default: return type
  }}

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(page, newPerPage);
        setPerPage(newPerPage);

    };


    useEffect(() => {
        fetchData(currentPage);
    }, [id]);

    const columns = [
        {
            name: t("anomaly_type"),
            selector: (row) => renderSignalementType(row.type),
        },
        {
            name:t("stop_point_address"),
            selector: (row) => row.points_passage.adresse?.label || t("address_not_available"),  // Assurez-vous que l'adresse est présente, sinon afficher un message par défaut
        },
        {
            name: 'Actions',
            button: true,
            cell: (row) => (
                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <div
                            onClick={() => {
                                setSignalement(row?._id)
                                setModalIsOpenDetail(true)
                            }}
                            style={{
                                cursor: 'pointer',
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="#51C7F2"
                                    d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
                                />
                                <path
                                    fill="#51C7F2"
                                    d="M11 7h2v7h-2zm0 8h2v2h-2z"
                                />
                            </svg>

                        </div>
                    </div>




                </div>
            ),
        },
    ];
    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);


    useEffect(() => {
        const checkIfMobile = () => {
            setSmallScreen(window.innerWidth <= 768);
        };
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    return (
        <LayoutChauffeur>
            <div style={{
                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '2rem', paddingBottom: '4rem', fontFamily: 'Montserrat', paddingLeft: '1.5rem',
                paddingRight: '1.5rem',
            }}>
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                        <div onClick={() => history.goBack()} style={{ background: '#51C7F2', width: isSmallScreen ? '1.5rem' : '3rem', height: isSmallScreen ? '1.5rem' : '3rem', borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <svg xmlns='http://www.w3.org/2000/svg' width={14.017} height={14.11} viewBox='0 0 14.017 14.11'>
                                <g fill='none' stroke='#fff' strokeWidth={2}>
                                    <path d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232' transform='translate(-8.838 -11.113)' />
                                    <path d='M22.147 11.818l-6.348 6.349 6.348 6.348' transform='translate(-8.838 -11.113)' />
                                </g>
                            </svg>
                        </div>
                        <div style={{ width: '1rem' }} />
                        <GradientText marginTop='unset' style={{
                            fontSize: isSmallScreen ? '2rem' : '2.5rem'
                        }}>
                            {t("reports").toUpperCase()}
                        </GradientText>

                    </div>
                    {chargementEnCours ?
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
                            <div className='customLoader'></div>
                        </div> :
                        isSmallScreen ?
                            signalements.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center' }}>{t("no_reports")}</div> :
                                signalements.map((signalement, index) => {
                                    return <div style={{
                                        width: '100%',
                                        background: '#E4EAF0',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '1rem',
                                        borderRadius: 10,
                                        alignItems: 'flex-start',
                                        marginBottom: 10,
                                    }}>
                                        <div style={{
                                            fontWeight: 'bolder',
                                            color: '#1C63C5',
                                            fontSize: '1.2rem',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            width: '100%',
                                            marginBottom : '1rem'
                                        }}>
                                            <span>{t("report_s")} N°{index + 1} </span>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}
                                                >
                                                    <div
                                                        onClick={() => {
                                                            setSignalement(signalement?._id)
                                                            setModalIsOpenDetail(true)
                                                        }}
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                fill="#51C7F2"
                                                                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
                                                            />
                                                            <path
                                                                fill="#51C7F2"
                                                                d="M11 7h2v7h-2zm0 8h2v2h-2z"
                                                            />
                                                        </svg>

                                                    </div>
                                                </div>




                                            </div>
                                        </div>
                                        <span style={{
                                            color: '#838EAB',
                                            marginBottom: '0.8rem',
                                            fontSize: '0.9rem',
                                        }}>
                                            {t("anomaly_type")} :{' '}
                                            <span style={{
                                                color: '#838EAB',
                                                fontWeight: 'bolder',
                                                fontSize: '0.9rem'
                                            }}>{signalement.type}</span>
                                        </span>
                                        <span style={{
                                            color: '#838EAB',
                                            fontSize: '0.9rem',
                                            marginBottom: '0.8rem',
                                        }}>
                                            {t("stop_point_address")} :{' '}
                                            <span style={{
                                                fontSize: '0.9rem',
                                                fontWeight: 'bolder',
                                                color: '#838EAB',
                                            }}>{signalement.points_passage.adresse?.label || t("address_not_available")}</span>
                                        </span>

                                    </div>
                                }) :
                            <div style={{ width: '100%', padding: '0 1rem', marginTop: '4rem' }}>
                                <DataTable
                                    columns={columns}
                                    data={signalements}
                                    progressPending={chargementEnCours}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent={t("no_reports")}
                                    progressComponent='Chargement'
                                    paginationComponentOptions={{
                                        rowsPerPageText: t("rows_per_page"),
                                        rangeSeparatorText: t("of"),
                                    }}
                                />
                            </div>
                    }
                </div>


            </div>
            <DetailsSignalementModal
                isOpen={modalIsOpenDetail}
                onClose={() => setModalIsOpenDetail(false)}
                signalementId={signalement}
            />

        </LayoutChauffeur>
    )
}
export default SignalerChauffeurAllMission;     